import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { href: "#about", label: "About" },
  { href: "#services", label: "Services" },
  { href: "#logistics", label: "Logistics" },
  { href: "#founder", label: "Founder" },
  { href: "#locations", label: "Locations" },
  { href: "#contact", label: "Contact" },
];

export const Nav = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="site-nav"
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        scrolled
          ? "backdrop-blur-xl bg-[#050914]/80 border-b border-white/10"
          : "bg-transparent"
      }`}
    >
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 h-20 flex items-center justify-between">
        <a
          href="#top"
          data-testid="nav-logo"
          className="flex items-center gap-3 group"
        >
          <span className="inline-block w-8 h-8 border border-[#d4af37] rotate-45 relative">
            <span className="absolute inset-1 bg-[#d4af37]/20" />
          </span>
          <span className="font-serif-editorial text-xl tracking-tight text-white leading-none">
            Richmond <span className="text-[#d4af37]">Holdings</span>
          </span>
        </a>

        <nav className="hidden md:flex items-center gap-10">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              className="link-gold text-[13px] uppercase tracking-[0.22em] text-slate-300 hover:text-white transition-colors"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <a
          href="#contact"
          data-testid="nav-cta-consult"
          className="hidden md:inline-flex items-center gap-2 bg-[#d4af37] hover:bg-[#f1d570] text-[#050914] px-5 py-3 text-[11px] font-bold uppercase tracking-[0.22em] transition-colors"
        >
          Book a Consult
        </a>

        <button
          data-testid="nav-mobile-toggle"
          onClick={() => setOpen((o) => !o)}
          className="md:hidden text-white p-2"
          aria-label="Toggle menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-[#050914]/95 backdrop-blur-xl border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-5">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                className="text-sm uppercase tracking-[0.22em] text-slate-200"
              >
                {l.label}
              </a>
            ))}
            <a
              href="#contact"
              onClick={() => setOpen(false)}
              data-testid="nav-mobile-cta"
              className="mt-2 inline-flex items-center justify-center bg-[#d4af37] text-[#050914] px-5 py-3 text-[11px] font-bold uppercase tracking-[0.22em]"
            >
              Book a Consult
            </a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Nav;
